<template>
  <div class="all-subscriptions-table">
    <AgGrid :options="gridOptions" :row-data="subscriptionPeriods">
      <template #header>
        <div class="text-subtitle-2 text-secondary-1">All subscriptions:</div>
      </template>
    </AgGrid>
  </div>
</template>

<script>
// Mixins
import { gridOptions } from './gridOptions'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [gridOptions],

  props: {
    subscriptionPeriods: Array
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.all-subscriptions-table {
  @include table-with-no-filters;
}
</style>
